"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDriver = void 0;
var neo4j_driver_1 = __importDefault(require("neo4j-driver"));
exports.createDriver = function (scheme, host, port, username, password, config) {
    if (!username || !password) {
        return neo4j_driver_1.default.driver(scheme + "://" + host + ":" + port);
    }
    return neo4j_driver_1.default.driver(scheme + "://" + host + ":" + port, neo4j_driver_1.default.auth.basic(username, password), config);
};
